import get from 'lodash/get';
import isArray from 'lodash/isArray';

import { actionLabel } from '../../utils/gradingReports';
import getInputActionNodes from './getInputActionNodes';

const actionTypeToGradingSection = {
  MEDICATION: 'medications',
  PROCEDURE: 'treatments',
  OXYGEN: 'oxygenRoutes',
  QUESTION: 'questions',
  COMMAND: 'commands',
  CALL: 'calls',
  PALPABLE_PULSE: 'assessments',
  COMPRESSION: 'treatments',
  PERSONAL_PROTECTIVE_EQUIPMENT: 'treatments',
  LEADS: 'treatments',
  PACING: 'treatments',
};

const actionTypeToCaseLogicIdKey = {
  OXYGEN: 'routes',
  LEADS: 'leads',
};

const actionTypeToCaseData = {
  MEDICATION: 'dosageForms',
  QUESTION: 'dialogue.questions',
  COMMAND: 'dialogue.commands',
  CALL: 'dialogue.calls',
};

function validateGradingConflicts(caseConf, nodeInfo) {
  const errors = [];
  const warnings = [];
  const gradeEffectNodes = nodeInfo.effectNodes.filter(
    (node) => get(node, 'data.effect.type') === 'GRADING'
  );
  gradeEffectNodes.forEach((effectNode) => {
    const inputActionNodes = getInputActionNodes(effectNode, nodeInfo.nodeMap);
    inputActionNodes.forEach((actionNode) => {
      const actionData = actionNode.data.action;
      if (!actionData) {
        return;
      }
      const caseLogicIdKey =
        actionTypeToCaseLogicIdKey[actionData.type] || 'id';
      const sectionGradingItems = caseConf.grading &&
        caseConf.grading[actionTypeToGradingSection[actionData.type]];
      const actionIdMatches = (id) =>
        id === actionData[caseLogicIdKey] ||
        (isArray(actionData[caseLogicIdKey]) &&
          actionData[caseLogicIdKey].includes(id));
      const matchingGradingItem = (sectionGradingItems || []).find(
        (gradingItem) => {
          return (
            (actionIdMatches(gradingItem.id) ||
              actionIdMatches(gradingItem.componentKey)) &&
            gradingItem.grade !== 'NEUTRAL'
          );
        }
      );
      if (!matchingGradingItem) {
        return;
      }
      let label;
      const caseData = get(caseConf, actionTypeToCaseData[actionData.type]);
      if (caseData) {
        if (actionData.type === 'MEDICATION') {
          label = 'Medication'; // medication labels aren't accessible with only caseConf data
        } else {
          const caseDataItem = caseData.find((item) => item.id === actionData.id);
          label =
            get(caseDataItem, 'label.en') ||
            get(caseDataItem, 'label') ||
            get(caseDataItem, 'name.en') ||
            get(caseDataItem, 'name') ||
            get(caseDataItem, 'content.en') ||
            get(caseDataItem, 'content') || '';
          label = label && label.length > 20 ? label.slice(0, 17) + '...' : label;
        }
      } else {
        label = actionLabel({
          type: actionData.type,
          typeID: actionIdMatches(matchingGradingItem.id)
            ? matchingGradingItem.id
            : matchingGradingItem.componentKey,
        });
      }
      warnings.push({
        message: `${label} is also assigned Grading in Case Logic`,
        category: 'grading',
        field: 'grading',
        metadata: {
          section: actionTypeToGradingSection[actionData.type],
          gradingItem: matchingGradingItem,
          defaultVisibility: false,
        },
      });
      warnings.push({
        message: `${label} is already being graded in the Grading tab`,
        category: 'caseLogic',
        field: 'caseLogicDescription',
        id: effectNode.id,
        metadata: {
          nodeId: effectNode.id,
          defaultVisibility: false,
        },
      });
    });
  });
  return {
    errors,
    warnings,
  };
}

export default validateGradingConflicts;
